import { render, staticRenderFns } from "./FieldWithTitle.vue?vue&type=template&id=72212f1f&scoped=true&"
import script from "./FieldWithTitle.vue?vue&type=script&lang=js&"
export * from "./FieldWithTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72212f1f",
  null
  
)

export default component.exports